import { DeleteIcon } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import { useCompanyAvailabilityDelete } from '@/core/domain/enterprise/company-availability/company-availability.hooks';
import {
  CompanyAvailability,
  CompanyAvailabilityDayOfWeekLabel,
} from '@/core/domain/enterprise/company-availability/company-availability.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Modal } from 'antd';

interface Props {
  item: CompanyAvailability;
}
export default function CompanyResourceAvaiableRemove(props: Props) {
  const companyAvailabilityDelete = useCompanyAvailabilityDelete();

  const hasRemovePermission = hasPermissions([
    Authorities.COMPANY_AVAILABILITY_DELETE,
  ]);

  const confirmRemove = () =>
    Modal.confirm({
      title: 'Remoção de disponibilidade de dia',
      content: `Deseja remove a disponibilidade de agendamento do dia "${
        CompanyAvailabilityDayOfWeekLabel[props.item.dayOfWeek]
      }"?`,
      okText: 'Remover',
      okButtonProps: { type: 'primary', danger: true },
      onOk: () => companyAvailabilityDelete.mutateAsync(props.item.id),
    });

  return (
    <ActionIcon onClick={confirmRemove} disabled={!hasRemovePermission}>
      <DeleteIcon />
    </ActionIcon>
  );
}
